import React, { useEffect } from "react";
import Buyer from "web/assets/images/landing-page-buyer.webp";
import Broker from "web/assets/images/landing-page-broker.webp";
import PTPLUS from "web/assets/images/landing-page-ptplus.webp";
import AOS from "aos";
import { useHistory } from 'react-router-dom';

import {
  Container,
  Wrapper,
  ToolsWrapper,
  ToolBox,
} from "web/pages/public/landing-page/HowItWork/PlansAndPricing/PlansAndPricingStyled";
import MembershipPlans from "./MembershipPlans";



const PlansAndPricing = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="400">
      <Wrapper>
        <h4 className="blue-text">Plans and Pricing</h4>
        <h4>
          Like everything else about PalletTrader, our plans are user-friendly.
        </h4>
        <h5 >
          Whether you’re a buyer or seller, just getting started, or
          well-established with multiple locations, our subscription pricing is
          designed to be simple and affordable.
        </h5>
        <MembershipPlans />
        {/* <img src={Technology} alt='Technology' /> */}
        {/* <ToolsWrapper>
          <ToolBox>
            <div className='imgWrapper'><img src={Buyer} alt="Buyer" /></div>
            <h6 style={{ marginTop: '0px' }}>Guest</h6>
            <h6 style={{ marginTop: '-10px' }}>{`(Buyer)`}</h6>
            <p>Free</p>
          </ToolBox>
          <ToolBox>
            <div className='imgWrapper'><img src={Broker} alt="Broker" /></div>
            <h6 style={{ marginTop: '0px' }}>Member</h6>
            <h6 style={{ marginTop: '-10px' }}>{`(Buyer or Seller)`}</h6>
            <p><span style={{textDecoration: 'line-through'}}>$79.00/month</span> / $0.00</p>
          </ToolBox>
          <ToolBox>
            <div className='imgWrapper'><img src={PTPLUS} alt="Ptplus" /></div>
            <h6 style={{ marginTop: '0px' }}>PalletTrader+</h6>
            <h6 style={{ marginTop: '-10px' }}>{`(Managed Solutions)`}</h6>
            <p>Monthly Subscription : $249</p>
          </ToolBox>
        </ToolsWrapper> */}
      </Wrapper>
    </Container>
  );
};

export default PlansAndPricing;
